import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../env";


export const fetchUnitOcc = createAsyncThunk(
  "report/fetchUnitOcc",
  async (HotelID) => {
    try {
      const response = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/unitwise-occupancy`, {
        params: { HotelID }
      });
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }
);

export const fetchbyHotelid = createAsyncThunk(
  "report/fetchbyHotelid",
  async (P_HotelID) => {
    try {
      const response = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/unitwise-occupancyproperty/${P_HotelID}`);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }
);


const reportSlice = createSlice({
  name: "report",
  initialState: {
    data: [],
    selectedHotel: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnitOcc.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUnitOcc.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchUnitOcc.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchbyHotelid.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchbyHotelid.fulfilled, (state, action) => {

        state.status = "succeeded";
        state.selectedBooking = action.payload;
        state.error = null;
      })
      .addCase(fetchbyHotelid.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

// Export reducer
export default reportSlice.reducer;